import Button from 'antd/lib/button';
import { useTranslation } from 'react-i18next';
import { CHINESE_SYMBOL, ENGLISH_SYMBOL } from 'i18n';
// import { localStorageService } from 'utils/LocalStorageService';
import { sessionStorageService } from 'utils/SessionStorageService';
import GlobalWhite from 'assets/images/g50-globe.svg';
import './LanguageSelector.less';
import { Space, Drawer, List } from 'antd';
import ArrowClose from 'assets/images/liHome/chevron-down.svg';
import ChevronLeft from 'assets/images/liHome/chevron-left.svg';

import { useState } from 'react';
// interface LanguageSelectorProps {
//   white: boolean; // 定义 props 类型
// }
type listProps = {
  icon?: string;
  title: string;
  navigate?: string;
  dropdown?: boolean;
};
interface navListProps {
  nlist: Array<listProps>;
}

const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const [openStutas, setOpenStutas] = useState(false);

  const changeLanguage = async (lang: string) => {
    let nextLang = '';
    if (lang == 'English') {
      nextLang = ENGLISH_SYMBOL;
    } else {
      nextLang = CHINESE_SYMBOL;
    }
    await i18n.changeLanguage(nextLang);
    sessionStorageService.set('i18nLanguage', nextLang);
    setOpenStutas(false);
  };
  const globeList = [
    {
      title: 'English',
    },
    {
      title: '繁',
    },
  ];
  const NavListL = ({ nlist }: navListProps) => {
    return (
      <div className="tabs-wrapper">
        <List
          style={{ color: 'white' }}
          itemLayout="horizontal"
          dataSource={nlist}
          renderItem={(item) => (
            <List.Item onClick={() => changeLanguage(item.title)} style={{ cursor: 'pointer' }}>
              <List.Item.Meta title={t(`${item.title}`)} />
            </List.Item>
          )}
        />
      </div>
    );
  };
  return (
    <>
      <Space
        align="center"
        size={4}
        style={{ height: '20px', lineHeight: '20px', marginTop: '39.5px' }}
        onClick={() => setOpenStutas(true)}
      >
        <img src={GlobalWhite} style={{ width: '20px', height: '20px' }} />
        <Button
          type="text"
          className={`change-lang size-f en-weight`}
          size="middle"
          style={{
            color: 'white',
            padding: '4px 4px',
          }}
          //   onClick={changeLanguage}
        >
          {i18n.language === 'en' ? 'EN' : '繁'}
          <img src={ArrowClose} style={{ marginLeft: '4px' }} />
        </Button>
      </Space>
      <Drawer
        placement="top"
        closable={false}
        onClose={() => setOpenStutas(false)}
        open={openStutas}
        headerStyle={{ display: 'none' }}
        bodyStyle={{ padding: '24px 0' }}
        height={202}
        maskClosable={false}
      >
        <div style={{ margin: '0 16px', cursor: 'pointer' }} onClick={() => setOpenStutas(false)}>
          <img src={ChevronLeft} alt="" style={{ verticalAlign: 'middle' }} />
          <span style={{ color: 'var(--primary-color)', marginLeft: '10px', verticalAlign: 'middle' }}>
            {t('life.home.back')}
          </span>
        </div>
        <NavListL nlist={globeList}></NavListL>
      </Drawer>
    </>
  );
};

export default LanguageSelector;
